import React, {useState, useEffect, useCallback, useRef} from 'react';
import {
    Layout,
    Menu,
    Avatar,
    Dropdown,
    Input,
    Card,
    Descriptions,
    Row,
    Col,
    Spin, Modal
} from 'antd';
import {UserOutlined} from '@ant-design/icons';
import debounce from 'lodash.debounce';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../app/store';
import {useTranslation} from 'react-i18next';
import {logout} from '../app/persistedSlice';
import {useHistory} from 'react-router-dom';
import {getTextColorFor} from '../helper/colorHelper';
import {useOnClickOutside} from "usehooks-ts";
import {useLazyGetApiMCompanySettingsByCompanyIdQuery} from "../api/services/company";
import {setError, setLoading} from "../features/app/appSlice";

const {Header} = Layout;

interface Person {
    id: string;
    name: string;
    summary: string;
}

const AppHeader: React.FC = () => {
    const {t, i18n} = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();

    const user = useSelector((state: RootState) => state?.auth?.user);
    const tenantInfo = useSelector((state: RootState) => state?.persisted?.tenantInfo);
    const themeColors = useSelector((state: RootState) => state?.app?.themeColors);

    // Menu handlers
    const logoutClicked = () => {
        dispatch(logout());
        history.push(`/${tenantInfo?.id}/`);
    };
    const profileClicked = () => {
        history.push(`/${tenantInfo?.id}/profile`);
    };

    // Dropdown menu
    const menu = (
        <Menu>
            <Menu.Item key="profile" onClick={profileClicked}>
                {t('profile')}
            </Menu.Item>
            <Menu.Item key="logout" onClick={logoutClicked}>
                {t('logout')}
            </Menu.Item>
            <Menu.SubMenu key="lang" title={t('language')}>
                <Menu.Item onClick={() => i18n.changeLanguage('en')}>English</Menu.Item>
                <Menu.Item onClick={() => i18n.changeLanguage('tr')}>Türkçe</Menu.Item>
            </Menu.SubMenu>
        </Menu>
    );

    return (
        <>
            <Header
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '0 24px',
                    background: themeColors?.primaryColor ?? '#fff',
                    backdropFilter: 'blur(10px)',
                    zIndex: 9999,
                }}
            >
                {/* Logo */}
                <div
                    className="logo"
                    style={{display: 'flex', alignItems: 'center', width: 200, height: 60}}
                >
                    <img
                        alt={tenantInfo?.name}
                        src={`${process.env.REACT_APP_API_BASE_URL}/api/image/images/companies/${tenantInfo?.logo}`}
                        style={{maxWidth: 200, height: 60, objectFit: 'contain'}}
                    />
                </div>

                {/* User dropdown */}
                <Dropdown
                    overlay={menu}
                    placement="bottomCenter"
                    trigger={['click']}
                    arrow
                >
                    <div style={{display: 'flex', alignItems: 'center', cursor: 'pointer'}}>
                        <Avatar icon={<UserOutlined/>}/>
                        <span style={{marginLeft: 8, color: getTextColorFor(themeColors?.primaryColor ?? '#000')}}>
            {user?.firstName} {user?.lastName}
          </span>
                    </div>
                </Dropdown>
            </Header>

        </>
    );
};

export default AppHeader;
